const STORAGE_KEY = 'affiliate-id';
const getStoredAffiliateId = ()=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient) {
        return '';
    }
    const json = window.sessionStorage.getItem(STORAGE_KEY);
    const affiliateId = json ? JSON.parse(json) : undefined;
    return affiliateId;
};
const setStoredAffiliateId = (id)=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient || !(id === null || id === void 0 ? void 0 : id.length)) {
        return false;
    }
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(id));
    return true;
};
const clearStoredAffiliateId = ()=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient) {
        return false;
    }
    window.sessionStorage.removeItem(STORAGE_KEY);
    return true;
};

export { clearStoredAffiliateId, getStoredAffiliateId, setStoredAffiliateId };
//# sourceMappingURL=affiliate-id-storage.js.map
